<template>
  <material-card-sba-small
    class="widget-card"
    :size.sync="internalSize"
    :order.sync="internalOrder"
    :height.sync="internalHeight"
    :maxOrderValue="maxOrderValue"
    :widgetIcon="widgetIcon"
    color="accent"
    :title="
      $t(
        'components.vue_material_dashboard.items.student_assistance_program.title'
      )
    "
  >
    <div v-if="image" class="image-slot" @click="goToStudentAssitanceProgram">
      <v-img
        :src="image"
        :alt="
          $t(
            'components.vue_material_dashboard.items.student_assistance_program.title'
          )
        "
        height="100%"
        width="100%"
        class="clickable-image"
      />
    </div>
    <v-card-text v-else class="my-5">
      <v-btn
        height="80"
        outlined
        x-large
        color="accent lighten-2"
        class="rounded-lg px-5 claim"
        @click="goToStudentAssitanceProgram"
      >
        <span class="accent--text claim-btn">
          {{
            $t(
              "components.vue_material_dashboard.items.student_assistance_program.button"
            )
          }}</span
        >
      </v-btn>
    </v-card-text>
  </material-card-sba-small>
</template>

<script>
import MaterialCardSbaSmall from "@/components/VueMaterialDashboard/material/MaterialCardSmallSbaDashboard.vue";
export default {
  components: {
    MaterialCardSbaSmall,
  },
  props: {
    widgetId: String,
    widgetIcon: String,
    image: String,
    size: Number,
    order: Number,
    height: Number,
    maxOrderValue: Number,
  },
  data() {
    return {
      internalSize: undefined,
      internalOrder: undefined,
      internalHeight: undefined,
    };
  },
  watch: {
    size: {
      handler(v) {
        this.internalSize = v;
      },
    },
    internalSize: {
      handler(v) {
        this.$emit("update:size", v);
      },
    },
    height: {
      handler(v) {
        this.internalHeight = v;
      },
    },
    internalHeight: {
      handler(v) {
        this.$emit("update:height", v);
      },
    },
    order: {
      handler(v) {
        this.internalOrder = v;
      },
    },
    internalOrder: {
      handler(v) {
        this.$emit("update-order", v);
      },
    },
  },
  mounted() {
    if (this.size !== null && this.size !== undefined) {
      this.internalSize = this.size;
    }
    if (this.height !== null && this.height !== undefined) {
      this.internalHeight = this.height;
    }
    if (this.order !== null && this.order !== undefined) {
      this.internalOrder = this.order;
    }
  },
  methods: {
    goToStudentAssitanceProgram() {
      window.open(
        "https://linkprotect.cudasvc.com/url?a=http%3a%2f%2fgetmaple.ca%2fstudenttrust&c=E,1,MZqfg0wO2eqtcz--3L9p_DivN1Son4A5qILxYqCZBT3wbGOX-NWIAswX0PZGqaC_aUw9JhRgzcUjgw5BHkzpBTEzcvThLE2JiGoSM3J-Yvu9mqWgHoRwJ06IQtGQ&typo=1"
      );
    },
  },
};
</script>
<style scoped>
.v-btn--outlined {
  border: 6px solid;
}
.claim-btn {
  font-weight: 700 !important;
}
.claim >>> .v-btn__content {
  max-width: 180px;
  white-space: normal !important;
  font-size: 1.25rem !important;
}
.clickable-image {
  cursor: pointer;
}
.widget-card {
  display: flex;
  flex-direction: column;
}
.widget-card >>> .v-card__title {
  flex: 0 0 auto;
}
.image-slot {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  cursor: pointer;
  padding: 8px;
}
.image-slot >>> .v-image {
  border-radius: 4px;
}
</style>
